import { render, staticRenderFns } from "./DomainSummarySuspiciousDonut.vue?vue&type=template&id=3692befe&scoped=true"
import script from "./DomainSummarySuspiciousDonut.vue?vue&type=script&lang=js"
export * from "./DomainSummarySuspiciousDonut.vue?vue&type=script&lang=js"
import style0 from "./DomainSummarySuspiciousDonut.vue?vue&type=style&index=0&id=3692befe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3692befe",
  null
  
)

export default component.exports